
<div [formGroup]="userDataForm">

    <mat-form-field>
      <input matInput placeholder="Clone User's Roles" [matAutocomplete]="cloneUsersRoles"
        formControlName="userSearchCtrlCloneRoles">
      <mat-autocomplete #cloneUsersRoles="matAutocomplete" [displayWith]="getDisplayName" (optionSelected)="selectUser()">
        <mat-option *ngFor="let user of (filteredUsersClone$ | async)" [value]="user">
          {{ user | displayName:true }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <button mat-raised-button class="mat-primary" color="accent" type="submit" (click)="cloneSelectedUserRoles()"
      [disabled]="!userDataForm.get('userSearchCtrlCloneRoles').valid || !selectedValidUser">Clone</button>

    <mat-form-field class="example-full-width">
      <input matInput placeholder="Select Role" aria-label="State" [appAutocomplete]="autoRole"
        [closeOnSelect]="false" formControlName="userSearchCtrlRoles">
      <mat-autocomplete #autoRole="matAutocomplete" (optionSelected)="selectRole($event)">
        <mat-option *ngFor="let role of (filteredRoles$ | async)" [value]="role">
          <mat-icon>add</mat-icon>{{role.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-list dense>
      <h3 mat-subheader>Roles</h3>
      <mat-list-item class="role-list-item" *ngFor="let role of userRoleList?.roles | orderBy: 'name'">
        {{role.name}}
        <div class="role-clear">
          <button mat-mini-fab color="white" (click)="removeRole(role.id)">
            <mat-icon aria-hidden="true">clear</mat-icon>
          </button>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="userRoleList?.roles?.length == 0" class="list-item-none">
        No Roles Found
      </mat-list-item>
    </mat-list>
</div>

